import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';

import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export class InventoryDocumentAssociatedWithGoodsIssueQuery extends Query<boolean> {
    public constructor(public readonly id: number) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(InventoryDocumentAssociatedWithGoodsIssueQuery)
export class InventoryDocumentAssociatedWithGoodsIssueQueryHandler implements QueryHandler<InventoryDocumentAssociatedWithGoodsIssueQuery, boolean> {
    #url = TaggedUrl.join('inventory/documents/:inventoryDocumentId/issuedGoods/any', [Tags.Api, Tags.NotHandle404]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: InventoryDocumentAssociatedWithGoodsIssueQuery): Promise<boolean> {
        const url = fillPlaceholders(this.#url, { inventoryDocumentId: query.id });
        return await this.#http.get<{ anyGoodsIssued: boolean; }>(url).then(response => response.data.anyGoodsIssued, () => false);
    }
}
